<script setup lang="ts">
import {computed} from 'vue';
import VChart from 'vue-echarts';
import type {EChartsOption, SeriesOption} from 'echarts';
import '@/base/echarts.js';
import {FASE_KLEUR, FaseVerdeling, formatFte, formatPercentage, InitiatiefFaseEnum_name} from 'common';

const props = defineProps<{
    verdeling: FaseVerdeling[];
    percentage: boolean;    // share of the geidentificeerd target instead of counts
}>();

const option = computed<EChartsOption>(() => ({
    grid   : {left: 8, right: 60, top: 8, bottom: 28, containLabel: true},
    tooltip: {trigger: 'axis'},
    xAxis  : {type: 'value', name: props.percentage ? '% van FTE-target' : 'Aantal initiatieven', nameLocation: 'middle', nameGap: 24, axisLabel: {formatter: props.percentage ? '{value}%' : '{value}'}},
    yAxis  : {type: 'category', inverse: true, data: props.verdeling.map(v => InitiatiefFaseEnum_name(v.fase))},
    series : [{
        type: 'bar',
        data: props.verdeling.map(v => ({
            value    : props.percentage ? (v.percentageVanTarget ?? 0) * 100 : v.aantal,
            itemStyle: {color: FASE_KLEUR[v.fase]},
            label    : {show: true, position: 'right', formatter: () => props.percentage ? `${formatFte(v.fte)} (${formatPercentage(v.percentageVanTarget)})` : `${v.aantal}`},
        })),
    } as unknown as SeriesOption],
}));
</script>

<template>
    <v-chart :option="option" autoresize :style="{height: '260px', width: '100%'}"/>
</template>
